(function ($) {
    var activeMenu = null, timer, MENU_TIMEOUT = 300, topLevelMenu = $(".site-nav-wrapper .site-nav > ul"), closeOpenDropDown = function () {
        if ($.fn.multiPurposeSelect && $.fn.multiPurposeSelect.openMenu) {
            $.fn.multiPurposeSelect.openMenu.close();
        } else {
            $("select").blur();
        }
    }, timeoutHandler = function () {
        
        closeOpenDropDown();
        topLevelMenu.addClass("menu-active");
        clearTimeout(timer);
    };
    if (!navigator.userAgent.match(/iPad/i)) {
        topLevelMenu.children("li:not('.nav-notifications')").hover(function () { $(".nav-notifications  .menu-panel").removeClass("visible"); timer = setTimeout(timeoutHandler, MENU_TIMEOUT); }, function () { clearTimeout(timer); topLevelMenu.removeClass("menu-active"); });
    } else {
        topLevelMenu.children("li:not('.nav-notifications')").each(function (i) {
            var item = $(this);
            if (i > 0) {
                item.children("a").on("click", function (event) {
                    var menuChild = $(this).next(".menu-panel");
                    if (activeMenu && activeMenu[0] !== menuChild[0]) {
                        item.parent().removeClass("menu-active");
                        activeMenu = null;
                    }
                    if (!activeMenu) {
                        activeMenu = menuChild;
                        event.preventDefault();
                        item.parent().addClass("menu-active");
                    }
                });
                item.on("touchstart", function (event) { event.stopPropagation(); });
            }
        });
        topLevelMenu.children("li:not('.nav-notifications')").find("li a").on("touchstart", function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            location.href = this.href;
        });
        $("body").on("touchstart", function (event) { if (activeMenu) { activeMenu.parent().removeClass("hover"); activeMenu = null; } });
    }
}(jQuery));